var Utils = (function (backOffice, $) {
    backOffice.Utils = (function () {

        function addBannerLoadEventListener(iframe) {
            document.addEventListener('bannerload', function () {
                let banner = document.getElementById("NotificationBanner");

                if (banner) {
                    let bannerHeightStyleProp = banner.clientHeight + 'px';
                    if (iframe.style.top !== bannerHeightStyleProp) {
                        iframe.style.top = bannerHeightStyleProp;

                        let frameHeight = iframe.clientHeight;
                        let bannerHeight = banner.clientHeight;

                        let newFrameHeightPercentage = Math.round(((frameHeight - bannerHeight) / (frameHeight / 100)));

                        iframe.style.height = newFrameHeightPercentage + '%';
                    }
                }
            }, false);
        }

        function limitTo2DecimalPlaces(number) {
            number = sanitiseMoney(number);
            if (!number || number.length == 0) {
                number = '';
            } else {
                if (number.indexOf(".") != -1) {
                    if ((number.length - number.indexOf(".")) > 3) {
                        var nNewValue = number.slice(0, number.indexOf(".") + 3);
                        return nNewValue;
                    }
                }
            }
            return number;
        }

        function sanitiseMoney(uncleanNumber) {
            return uncleanNumber.replace(/[^-0-9.]/g, "");
        }

        function limitToInteger(number) {
            number = parseInt(number, 10);
            if (!number || number.length == 0) {
                number = '';
            };
            return number;

        }

        function allowOnlyNumericWithKeys(event, allowedKeys) {
            if (allowedKeys) {
                var allowKeyList = allowedKeys.split(',');
                for (var i = 0; i < allowKeyList.length; i++) {
                    if (parseInt(allowKeyList[i]) === event.keyCode) {
                        return;
                    }
                }
            }

            return AllowOnlyNumericInput(event);
        }

        function AllowOnlyNumericInput(event) {
            // Allow: special characters
            if (event.keyCode == 46 ||  // Allow: Deletes
                event.keyCode == 8 ||   // Allow: BackSpace 
                event.keyCode == 9 ||   // Allow: Tab  
                event.keyCode == 27 ||  // Allow: Escape  
                event.keyCode == 190 || // Allow: period colon 
                event.keyCode == 110 || // Allow: KP_Decimal 
                event.keyCode == 109 || // Allow: KP_Subtract  
                event.keyCode == 189 || // Allow: minus underscore 
                (event.keyCode == 65 && event.ctrlKey === true) || // Allow: Ctrl+A
                (event.keyCode == 67 && event.ctrlKey === true) || // Allow: Ctrl+C
                (event.keyCode == 86 && event.ctrlKey === true) || // Allow: Ctrl+V
                (event.keyCode == 88 && event.ctrlKey === true) || // Allow: Ctrl+X
                (event.keyCode >= 35 && event.keyCode <= 39)) { // Allow: home, end, left, right
                return;
            } else {
                // Ensure that it is a number and stop the keypress
                if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || (event.keyCode > 105))) {
                    if (event.preventDefault) {
                        event.preventDefault();
                    } else {
                        event.returnValue = false;
                    }
                }
            }

        }

        function GetXmlHttpObject(handler) {
            var objXmlHttp = null

            if (navigator.userAgent.indexOf("Opera") >= 0) {
                alert("This function doesn't work in Opera")
                return
            }
            if (navigator.userAgent.indexOf("MSIE") >= 0) {
                var strName = "Msxml2.XMLHTTP"
                if (navigator.appVersion.indexOf("MSIE 5.5") >= 0) {
                    strName = "Microsoft.XMLHTTP"
                }
                try {
                    objXmlHttp = new ActiveXObject(strName)
                    objXmlHttp.onreadystatechange = handler
                    return objXmlHttp
                }
                catch (e) {
                    alert("Error. Scripting for ActiveX might be disabled")
                    return
                }
            }
            if (navigator.userAgent.indexOf("Mozilla") >= 0) {
                objXmlHttp = new XMLHttpRequest()
                objXmlHttp.onload = handler
                objXmlHttp.onerror = handler
                return objXmlHttp
            }
        }

        function HandleDuplicateResponse(inputId, isManufacturerSKU, barcodeSearch, showMessage, callback) {
            if (xmlHttp.readyState == 4 || xmlHttp.readyState == 'complete') {
                try {
                    var sku = document.getElementById(inputId);
                    if (xmlHttp.responseText.match('duplicate') != null) {
                        if (showMessage) {
                            if (isManufacturerSKU) {
                                alert('Manufacturer SKU must be unique');
                            }
                            else {
                                if (barcodeSearch) {
                                    alert('Supplier SKU must be unique (entered value matches existing Supplier SKU or Barcode)');
                                }
                                else {
                                    alert('Supplier SKU must be unique');
                                }
                            }
                        }
                        sku.IsUnique = 'false';
                    }
                    else {
                        sku.IsUnique = 'true';
                    }
                    if (callback) {
                        callback();
                    }
                }
                catch (e) {
                    sku.IsUnique = 'false';
                    alert('There was a problem communicating to the server, please try again shortly and if the problem persists contact support');
                }
            }
        }

        function CheckUniqueSKU(sku, productId, inputId, barcodeSearch, showMessage, callback) {
            url = window.location.origin +
                '/Admin/Inventory/ProductMaint/ajaxCheckUniqueSKU.asp?sku=' +
                sku +
                '&ProductId=' +
                productId +
                '&BarcodeSearch=' +
                barcodeSearch || '';

            xmlHttp = GetXmlHttpObject(function () {
                HandleDuplicateResponse(inputId, false, barcodeSearch, showMessage, callback)
            })
            xmlHttp.open("POST", url, false)
            xmlHttp.send(null)
        }

        function CheckUniqueManufacturerSKU(sku, productId, inputId, showMessage) {
            url = window.location.origin +
                '/Admin/Inventory/ProductMaint/ajaxCheckUniqueSKU.asp?sku=' +
                sku +
                '&ProductId=' +
                productId +
                '&kind=manufacturer';

            xmlHttp = GetXmlHttpObject(function () {
                HandleDuplicateResponse(inputId, true, false, showMessage)
            })
            xmlHttp.open("POST", url, false)
            xmlHttp.send(null)
        }

        function getCookie(key) {
            var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
            return keyValue ? keyValue[2] : null;
        }

        function setCookie(cName, cValue, expire) {
            let date = new Date();
            date.setTime(date.getTime() + expire);
            const expires = "expires=" + date.toUTCString();
            document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";           
        }

        function mapToIntegers(arr) {
            var mapToIntegersFunc = function (arr) {
                return filterValid(arr).map(function (v) { return parseInt(v) })
            };

            return processArraySafe(arr, mapToIntegersFunc);
        }

        function filterValid(arr) {
            var filterValidFunc = function (arr) {
                return arr.filter(function (i) { return !!i })
            };

            return processArraySafe(arr, filterValidFunc);
        }

        function processArraySafe(arr, processingFunc) {
            if (Array.isArray(arr)) {
                if (processingFunc) {
                   return processingFunc(arr);
                }
            }

            return arr;
        }

        function validateEmail(email) {
            var regex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            return email && email.length < 255 && regex.test(email);
        }

        function getISODateFromDateString(dateStr) {
            if (dateStr != null && dateStr != 'undefined' && typeof dateStr === 'string' && dateStr.trim().length !== 0) {
                return dateStr.split('/').reverse().join("-");
            }
        }

        function getISODateFromDateTimeString(dateTime) {
            var date = dateTime;
            var delimeterSpaceIdx = dateTime.indexOf(" ");
            if (delimeterSpaceIdx !== -1) {
                date = dateTime.substring(0, delimeterSpaceIdx);
            }
            // iso date format
            return getISODateFromDateString(date);
        }

        function getISODateTimeFromDateTimeString(dateTime) {
            return getISODateFromDateTimeString(dateTime) + ' ' + getTimeFromDateTimeString(dateTime);
        }

        function getTimeFromDateTimeString(dateTime) {
            var delimeterSpaceIdx = dateTime.indexOf(" ");
            return dateTime.substring(delimeterSpaceIdx + 1);
        }


        function arrayOrNull(arr) {
            return arr && arr.length ? arr : null;
        }

        function integersOrNull(arr) {
            return arrayOrNull(mapToIntegers(arr));
        }


        function getCustomAttributeValueIds(attributeSelectElements, startFromIdx) {
            var ids = [];

            if (attributeSelectElements
                && attributeSelectElements.length) {
                for (var i = startFromIdx; i < attributeSelectElements.length; i++) {
                    var attributeSelectSelector = attributeSelectElements[i].id;

                    //escape forbidden characters
                    attributeSelectSelector = '#' + attributeSelectSelector.replace(/([.,*#+?:;%^=!&${}()|\[\]\/\\ ])/g, "\\$1");

                    if (Array.isArray($(attributeSelectSelector).val())) {
                        var selectedValues = $(attributeSelectSelector).val().join(",");

                        ids.push(selectedValues);
                    }
                }
            }

            return ids;
        }

        function valueOrNull(value) {
            return value ? value : null;
        }

        function arrayOrNull(arr) {
            return arr && arr.length ? arr : null;
        }

        function integersOrNull(arr) {
            return arrayOrNull(mapToIntegers(arr));
        }

        function preventDefaultKeyPressForElement(elementId, key) {
            var gridElemenent = document.getElementById(elementId);
            if (gridElemenent) {
                gridElemenent.addEventListener("keypress",
                    function (event) {
                        if (event.key === key) {
                            event.preventDefault();
                        }
                    });
            }
        }

        function redirectTo(redirectUrl) {
            var url = window.location.origin + redirectUrl;

            window.location.replace(url);
        }

        function addSerialValidationEventListeners() {
            var serialInputs = document.querySelectorAll('.serial-validation');

            serialInputs.forEach(function (input) {
                // Filter typed input
                input.addEventListener('input', function () {
                    this.value = this.value.replace(/[^A-Za-z0-9\-\/._#]/g, '');
                });

                // Filter pasted input
                input.addEventListener('paste', function (e) {
                    e.preventDefault(); // STOP browser from auto-pasting

                    // Get pasted data
                    var clipboardData = (e.clipboardData || window.clipboardData);
                    if (!clipboardData) return;

                    var paste = clipboardData.getData('text') || '';
                    var cleaned = paste.replace(/[^A-Za-z0-9\-\/._#]/g, '');

                    // Insert cleaned text manually
                    var start = input.selectionStart;
                    var end = input.selectionEnd;
                    var currentValue = input.value;

                    input.value = currentValue.slice(0, start) + cleaned + currentValue.slice(end);
                    input.setSelectionRange(start + cleaned.length, start + cleaned.length);
                });
            });
        }
        return {
            CheckUniqueSKU: CheckUniqueSKU,
            GetXmlHttpObject: GetXmlHttpObject,
            CheckUniqueManufacturerSKU: CheckUniqueManufacturerSKU,
            AllowOnlyNumericInput: AllowOnlyNumericInput,
            AllowOnlyNumericWithKeys: allowOnlyNumericWithKeys,
            LimitTo2DecimalPlaces: limitTo2DecimalPlaces,
            LimitToInteger: limitToInteger,
            GetCookie: getCookie,
            SetCookie: setCookie,
            AddBannerLoadEventListener: addBannerLoadEventListener,
            FilterValid: filterValid,
            MapToIntegers: mapToIntegers,
            ValidateEmail: validateEmail,
            GetISODateFromDateString: getISODateFromDateString,
            GetISODateFromDateTimeString: getISODateFromDateTimeString,
            GetISODateTimeFromDateTimeString: getISODateTimeFromDateTimeString,
            GetTimeFromDateTimeString: getTimeFromDateTimeString,
            GetCustomAttributeValueIds: getCustomAttributeValueIds,
            PreventDefaultKeyPressForElement: preventDefaultKeyPressForElement,
            ValueOrNull: valueOrNull,
            ArrayOrNull: arrayOrNull,
            IntegersOrNull: integersOrNull,
            RedirectTo: redirectTo,
            AddSerialValidationEventListeners: addSerialValidationEventListeners
        };
    })();
    return backOffice.Utils;
})(BackOffice || {}, jQuery);
